import { render } from "./distpachedit.vue?vue&type=template&id=2c5614cd"
import script from "./distpachedit.vue?vue&type=script&lang=js"
export * from "./distpachedit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__